import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation resetPinCounter($cardId: ID!) {
      resetPinCounter(cardId: $cardId) {
        isReset
      }
    }
  `,
  config: {
    skip: (ownProps) => !ownProps.cardId,
    options: ({ cardId }) => ({
      variables: {
        cardId,
      },
    }),
  },
  propTypes: {
    cardId: PropTypes.string.isRequired,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/cards/resetCardPinCounter.js